/**
 * Supabase Configuration Constants
 * ============================================================================
 * ⚠️ SINGLE SOURCE OF TRUTH - Frontend Supabase Credentials
 * ============================================================================
 * 
 * All frontend code MUST import from this file instead of hardcoding values.
 * Do NOT use VITE_* environment variables - they are deprecated.
 * 
 * Key: tax-network-frontend-publishable
 * Description: Frontend publishable key for Tax Network web application.
 *              Used for authenticated user requests with RLS enforcement.
 * 
 * For backend (edge functions): Use Deno.env.get('SUPABASE_*')
 * For GitHub Actions: Use repository secrets
 * For pg_cron jobs: Use current_setting('supabase.service_role_key', true)
 * 
 * @see docs/GITHUB_WORKFLOWS_SECRETS.md for CI/CD configuration
 */

export const SUPABASE_PROJECT_ID = 'mnwkwoxlplzzytotqjcf';
export const SUPABASE_URL = `https://${SUPABASE_PROJECT_ID}.supabase.co`;

/**
 * Publishable key (sb_publishable_* format) - safe to expose in frontend code.
 * This key is verified by Supabase's API Gateway, which then mints a short-lived
 * JWT for the request. RLS policies apply based on anon/authenticated role.
 * 
 * For authenticated users, the SDK automatically sends both:
 * - apikey header: this publishable key (for API access)
 * - Authorization header: user's session JWT (for identity)
 */
export const SUPABASE_ANON_KEY = 'sb_publishable_nuA_VLT4-SBfu6lH6zs5Bw_u5NnAfuU';
